module.exports = __webpack_public_path__ + "media/images/press_kit/norwegian_cruise_line_holdings/login/1_ncl-56717a8aa04c1faa77058495c9026802.png";